import getConfig from './config';

export default async function isCDRCategoryId(categoryId?: string) {
  const config = await getConfig();
  return categoryId === config.CDR_CATEGORY_ID;
}
